import React from "react"
import ClickTracker from "@components/click-tracker"
import { splitId } from "@components/content-feed/admin/manager"
import renderDetailLink from "@components/content-feed/util/renderDetailLink";

export const VIEW_ACTION_DETAIL = "DETAIL"
export const VIEW_ACTION_URL = "URL"

export const Link = ({
  id,
  teaserId,
  view_action,
  detailId,
  detail_asset_id,
  url,
  children,
}) => {
  teaserId = splitId(teaserId)
  const itemId = splitId(id)

  if (view_action === VIEW_ACTION_DETAIL && detailId) {
    return (
      <a
        className="content-feed-link"
        href={renderDetailLink({
          detailId: detailId,
          assetId: detail_asset_id,
          teaserId,
          itemId,
        })}
      >
        {children}
      </a>
    )
  } else if (view_action === VIEW_ACTION_URL && url) {
    return (
      <ClickTracker
        name="feed_checkpoint"
        aid={itemId}
        tag="a"
        className="content-feed-link"
        href={url}
      >
        {children}
      </ClickTracker>
    )
  } else {
    return <>{children}</>
  }
}

export default Link
